import { initialValType } from "../../../../hooks/useFormValidation"
import { CommonErrorText } from "./../../../../common/errorText"

export const validateLogin = (initialstate: initialValType) => {
  let errors = {}
  const { username, password, first, second } = initialstate

  if (username === "") {
    errors = Object.assign(errors, {
      username: CommonErrorText.usernameError
    })
  }
  if (password === "") {
    errors = Object.assign(errors, {
      password: CommonErrorText.passworderror
    })
  }

  if (first === "") {
    errors = Object.assign(errors, {
      first: "Please enter pass phrase characters"
    })
  }
  if (second === "") {
    errors = Object.assign(errors, {
      second: "Please enter pass phrase characters"
    })
  }
  return errors
}
